<template>
  <div>
    <NavBar />
    <div class="container">
      <b-overlay :show="loadingBranch" opacity="0.99">
        <div class="row">
          <div class="col-md-12">
            <v-btn class="v-primary" @click="$router.go(-1)">
              <span class="fa fa-arrow-left"></span> Voltar
            </v-btn>
          </div>
          <div class="col-md-12">
            <h3>
              <span class="text-muted">FILIAL:</span>
              {{ branch.name }}
            </h3>
          </div>

          <div class="col-md-12">
            <form v-on:submit="update" method="post">
              <div class="row">
                <div class="col-md-12">
                  <LabelRequiredField label="Nome" />
                  <input type="text" v-model="name" class="form-control" />
                  <ErrorsMessages :errors="errors" />
                </div>
                <div class="col-md-12 text-right">
                  <v-btn
                    class="v-secondary m-1"
                    @click="
                      errors = [];
                      $bvModal.show('createBranchRestHome');
                    "
                  >
                    <span class="fa fa-plus"></span> Vincular cliente
                  </v-btn>
                  <b-modal id="createBranchRestHome" hide-footer>
                    <template v-slot:modal-title>Vincular cliente</template>
                    <div class="d-block">
                      <div class="container">
                        <form v-on:submit="createBranchRestHome" method="post">
                          <div class="row">
                            <ErrorsMessages :errors="errors" />
                            <div class="col-md-12">
                              <label>Cliente</label>
                              <select
                                v-model="rest_home_id"
                                class="form-control"
                              >
                                <option value>Selecione...</option>
                                <option
                                  v-for="value in clients"
                                  :key="value.id"
                                  :value="value.id"
                                >
                                  {{ value.name }}
                                </option>
                              </select>
                            </div>
                            <div class="col-md-12 text-right">
                              <v-btn
                                :disabled="loadingCreateBranchRestHome"
                                type="submit"
                                class="v-success"
                              >
                                <span class="fa fa-check"></span>
                                {{
                                  loadingCreateBranchRestHome
                                    ? "Carregando"
                                    : "Salvar"
                                }}
                              </v-btn>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </b-modal>
                  <v-btn
                    :disabled="loadingUpdate"
                    type="submit"
                    class="m-1 v-success"
                  >
                    <span class="fa fa-check"></span>
                    {{ loadingUpdate ? "Carregando" : "Salvar" }}
                  </v-btn>
                </div>
              </div>
            </form>
          </div>

          <div class="col-md-12">
            <h6 class="m-0">
              <span class="text-muted">Criação:</span>
              {{ formatDate(branch.created_at) }}
            </h6>
            <h6 class="m-0">
              <span class="text-muted">Última alteração:</span>
              {{ formatDate(branch.updated_at) }}
            </h6>
          </div>

          <div class="col-md-12">
            <b-overlay :show="loadingBranchRestHome" opacity="0.99">
              <v-card>
                <v-card-title>
                  Clientes
                  <v-spacer />
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar"
                    single-line
                    hide-details
                  />
                </v-card-title>
                <v-data-table
                  dense
                  :headers="headers"
                  :items="branch_rest_homes"
                  :search="search"
                  class="elevation-1"
                  :footer-props="{
                    'items-per-page-options': [25, 75, 100],
                    'items-per-page-text': 'Mostrar',
                  }"
                  @click:row="handleClickRowTable"
                >
                  <template v-slot:[`item.status`]="{ item }">{{
                    item.status == 1 ? "ATIVO" : "INATIVO"
                  }}</template>
                  <template v-slot:[`item.edit`]="{ item }">
                    <b-modal :id="String(item.id)" hide-footer size="sm">
                      <template v-slot:modal-title
                        >Editar status do cliente</template
                      >
                      <div class="d-block">
                        <div class="container">
                          <b-overlay opacity="0.99">
                            <form
                              v-on:submit="updateBranchRestHome"
                              method="post"
                            >
                              <div class="row">
                                <ErrorsMessages :errors="errors" />
                                <div class="col-md-12">
                                  <LabelRequiredField label="Status" />
                                  <select v-model="status" class="form-control">
                                    <option :value="1">ATIVO</option>
                                    <option :value="0">INATIVO</option>
                                  </select>
                                </div>
                                <div class="col-md-12 text-right">
                                  <v-btn
                                    class="v-primary m-1"
                                    @click="$bvModal.hide(String(item.id))"
                                  >
                                    <span class="fa fa-arrow-left"></span>
                                    Voltar
                                  </v-btn>
                                  <v-btn
                                    :disabled="loadingUpdateBranchRestHome"
                                    type="submit"
                                    class="v-success m-1"
                                  >
                                    <span class="fa fa-check"></span>
                                    {{
                                      loadingUpdateBranchRestHome
                                        ? "Carregando"
                                        : "Salvar"
                                    }}
                                  </v-btn>
                                </div>
                              </div>
                            </form>
                          </b-overlay>
                        </div>
                      </div>
                    </b-modal>
                  </template>
                </v-data-table>
              </v-card>
            </b-overlay>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import LabelRequiredField from "../templates/components/LabelRequiredField";

import ErrorsMessages from "../templates/components/ErrorsMessages";

import NavBar from "../templates/NavBar";

import api from "../services/api";

import routes from "../routes";

import toast from "../components/ToastNotification";

import {
  formatPrice,
  formatValueOnKeyUp,
  formatDate,
} from "../functions/format";

export default {
  name: "Branch",
  components: {
    NavBar,
    LabelRequiredField,
    ErrorsMessages,
  },
  data() {
    return {
      errors: [],

      search: "",

      headers: [
        { text: "Status", sortable: false, value: "status" },
        { text: "Cliente", sortable: false, value: "rest_home_name" },
        { align: "end", text: "", sortable: false, value: "edit" },
      ],

      id: "",

      branch: {},

      branch_rest_homes: [],

      clients: [],

      rest_home_id: "",

      name: "",

      status: "",

      loadingBranch: true,

      loadingBranchRestHome: true,

      loadingUpdate: false,

      loadingUpdateBranchRestHome: false,

      loadingCreateBranchRestHome: false,

      branch_rest_home_id: "",
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatPrice,
    formatValueOnKeyUp,
    formatDate,

    handleClickRowTable(item) {
      this.errors = [];
      this.branch_rest_home_id = item.id;
      this.status = item.status;
      this.$bvModal.show(String(item.id));
    },

    async retrieve() {
      const { id } = routes.history.current.params;

      if (!id) {
        routes.push({ name: "branchs" });
        return;
      }

      this.id = id;

      await this.getClients();
      await this.getBranch();
      await this.getBranchRestHome();
    },

    async getClients() {
      try {
        const response = await api.get("/clients");

        const { clients } = response.data;

        this.clients = clients;
      } catch (error) {
        console.log(error);
      }
    },

    async getBranch() {
      try {
        this.loadingBranch = true;

        let { id } = this;

        const response = await api.get("/branch", {
          params: { id },
        });

        const { branch } = response.data;

        this.branch = branch;

        this.name = branch.name;

        this.loadingBranch = false;
      } catch (error) {
        console.log(error);
      }
    },

    async update(event) {
      event.preventDefault();

      this.loadingUpdate = true;

      try {
        const { id, name } = this;

        let params = { id, name };

        const response = await api.patch("/branch", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.getBranch();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getBranchRestHome() {
      try {
        this.loadingBranchRestHome = true;

        let { id: branch_id } = this;

        const response = await api.get("/branchresthomes", {
          params: { branch_id },
        });

        const { branch_rest_homes } = response.data;

        this.branch_rest_homes = branch_rest_homes;

        this.loadingBranchRestHome = false;
      } catch (error) {
        console.log(error);
      }
    },

    async createBranchRestHome(event) {
      event.preventDefault();

      this.loadingCreateBranchRestHome = true;

      try {
        const { id: branch_id, rest_home_id } = this;

        let params = {
          branch_id,
          rest_home_id,
        };

        const response = await api.post("/branchresthome", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.getBranchRestHome();
          this.$bvModal.hide("createBranchRestHome");
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingCreateBranchRestHome = false;
      } catch (error) {
        console.log(error);
      }
    },

    async updateBranchRestHome(event) {
      try {
        event.preventDefault();

        this.loadingUpdateBranchRestHome = true;

        const { branch_rest_home_id, status } = this;

        let params = { id: branch_rest_home_id, status };

        const response = await api.patch("/branchresthome", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.getBranchRestHome();
          this.$bvModal.hide(String(branch_rest_home_id));
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingUpdateBranchRestHome = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>